import React from 'react'
import "./Plans.css"
import whitetick from "../../assets/whiteTick.png"
const Plans = () => {
  const plansData = [
    {
      icon: (
        <svg
          width="15"
          height="13"
          viewBox="0 0 15 13"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.01789 5.76762H8.26715V5.03093C8.26715 4.83555 8.18806 4.64816 8.04727 4.51001C7.90648 4.37185 7.71552 4.29424 7.51641 4.29424C7.3173 4.29424 7.12635 4.37185 6.98556 4.51001C6.84477 4.64816 6.76567 4.83555 6.76567 5.03093V5.76762H6.01493C5.81582 5.76762 5.62487 5.84524 5.48408 5.98339C5.34329 6.12155 5.26419 6.30893 5.26419 6.50431C5.26419 6.6997 5.34329 6.88708 5.48408 7.02523C5.62487 7.16339 5.81582 7.24101 6.01493 7.24101H6.76567V7.9777C6.76567 8.17308 6.84477 8.36046 6.98556 8.49862C7.12635 8.63678 7.3173 8.71439 7.51641 8.71439C7.71552 8.71439 7.90648 8.63678 8.04727 8.49862C8.18806 8.36046 8.26715 8.17308 8.26715 7.9777V7.24101H9.01789C9.217 7.24101 9.40796 7.16339 9.54875 7.02523C9.68954 6.88708 9.76864 6.6997 9.76864 6.50431C9.76864 6.30893 9.68954 6.12155 9.54875 5.98339C9.40796 5.84524 9.217 5.76762 9.01789 5.76762ZM13.6425 1.34746C12.8419 0.570035 11.7846 0.0989691 10.6613 0.0192671C9.53795 -0.0604348 8.42257 0.256476 7.51641 0.912815C6.56121 0.215636 5.37229 -0.100497 4.18907 0.0280747C3.00585 0.156647 1.91622 0.720375 1.1396 1.60574C0.362984 2.4911 -0.0429299 3.63233 0.00360011 4.79962C0.0501301 5.9669 0.545648 7.07353 1.39037 7.89666L5.89481 12.3537C6.31711 12.7675 6.88954 13 7.48638 13C8.08322 13 8.65566 12.7675 9.07795 12.3537L13.5824 7.89666C14.026 7.47133 14.3796 6.96416 14.6229 6.4043C14.8661 5.84443 14.9942 5.24291 14.9998 4.63432C15.0054 4.02572 14.8883 3.42203 14.6554 2.85796C14.4225 2.2939 14.0782 1.78056 13.6425 1.34746ZM12.5839 6.84319L8.07947 11.2633C8.00968 11.3324 7.92664 11.3872 7.83516 11.4246C7.74368 11.462 7.64555 11.4813 7.54644 11.4813C7.44734 11.4813 7.34921 11.462 7.25773 11.4246C7.16624 11.3872 7.08321 11.3324 7.01342 11.2633L2.50897 6.84319C1.92021 6.25262 1.59052 5.45929 1.59052 4.63311C1.59052 3.80694 1.92021 3.01361 2.50897 2.42304C3.10893 1.84178 3.91809 1.51585 4.76119 1.51585C5.6043 1.51585 6.41346 1.84178 7.01342 2.42304C7.08321 2.49208 7.16624 2.54689 7.25773 2.58429C7.34921 2.62169 7.44734 2.64095 7.54644 2.64095C7.64555 2.64095 7.74368 2.62169 7.83516 2.58429C7.92664 2.54689 8.00968 2.49208 8.07947 2.42304C8.67943 1.84178 9.48859 1.51585 10.3317 1.51585C11.1748 1.51585 11.984 1.84178 12.5839 2.42304C13.1772 3.01427 13.5097 3.81073 13.5097 4.64048C13.5097 5.47023 13.1772 6.2667 12.5839 6.85793V6.84319Z" />
        </svg>
      ),
      name: "BASIC PLAN",
      price: "25",
      features: [
        "2 hours of excercises",
        "Free consultaion to coaches",
        "Access to The Community",
      ],
    },
    {
      icon: (
        <svg
          width="28"
          height="24"
          viewBox="0 0 28 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3.11111 18L0 1.5L8.55556 9L14 0L19.4444 9L28 1.5L24.8889 18H3.11111ZM24.8889 22.5C24.8889 23.4 24.2667 24 23.3333 24H4.66667C3.73333 24 3.11111 23.4 3.11111 22.5V21H24.8889V22.5Z" />
        </svg>
      ),
      name: "PREMIUM PLAN",
      price: "30",
      features: [
        "5 hour of excercises",
        "Free consultaion of Coaches",
        "Accessto minibar",
      ],
    },
    {
      icon: (
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12.3812 3.41487L10.1103 1.2853C10.0359 1.21502 9.9475 1.15924 9.85006 1.12117C9.75262 1.0831 9.64811 1.0635 9.54255 1.0635C9.437 1.0635 9.33248 1.0831 9.23505 1.12117C9.13761 1.15924 9.04917 1.21502 8.97484 1.2853C8.82591 1.4258 8.74232 1.61585 8.74232 1.81395C8.74232 2.01204 8.82591 2.20209 8.97484 2.34259L10.67 3.93226L4.1932 10.006L2.49804 8.41634C2.34822 8.27668 2.14556 8.19829 1.93432 8.19829C1.72307 8.19829 1.52041 8.27668 1.3706 8.41634C1.29565 8.48605 1.23616 8.56898 1.19557 8.66036C1.15497 8.75173 1.13407 8.84974 1.13407 8.94873C1.13407 9.04772 1.15497 9.14573 1.19557 9.2371C1.23616 9.32848 1.29565 9.41141 1.3706 9.48112L3.61748 11.5882L5.86437 13.6953C5.93843 13.7661 6.02674 13.8225 6.12419 13.8611C6.22164 13.8997 6.3263 13.9198 6.43209 13.9202C6.59091 13.9211 6.74641 13.8776 6.87876 13.7952C7.01111 13.7129 7.11432 13.5955 7.17522 13.4579C7.23612 13.3204 7.25197 13.1689 7.22073 13.0229C7.18949 12.8769 7.11258 12.7429 6.99981 12.638L5.32864 11.0708L11.8054 4.99704L13.5006 6.58672C13.5751 6.65614 13.6636 6.71111 13.7608 6.74849C13.858 6.78587 13.9621 6.80494 14.0671 6.80459C14.1722 6.80424 14.2762 6.78449 14.3731 6.74646C14.47 6.70844 14.558 6.65288 14.632 6.58297C14.7061 6.51305 14.7647 6.43015 14.8045 6.33899C14.8444 6.24783 14.8647 6.1502 14.8644 6.05167C14.864 5.95315 14.8429 5.85566 14.8024 5.76476C14.7618 5.67387 14.7026 5.59136 14.628 5.52193L12.3812 3.41487ZM1.3706 11.5957C1.22003 11.4545 1.01581 11.3752 0.802876 11.3752C0.58994 11.3752 0.385725 11.4545 0.235157 11.5957C0.0845885 11.7369 1.5865e-09 11.9284 0 12.1281C-1.5865e-09 12.3278 0.0845885 12.5193 0.235157 12.6605L2.49804 14.7825C2.57275 14.852 2.66136 14.907 2.75878 14.9443C2.85621 14.9816 2.96052 15.0006 3.06576 15C3.17099 15.0006 3.27531 14.9816 3.37273 14.9443C3.47015 14.907 3.55876 14.852 3.63348 14.7825C3.70842 14.7128 3.76791 14.6299 3.8085 14.5385C3.8491 14.4471 3.87 14.3491 3.87 14.2501C3.87 14.1512 3.8491 14.0531 3.8085 13.9618C3.76791 13.8704 3.70842 13.7875 3.63348 13.7178L1.3706 11.5957ZM15.7635 2.34259L13.5006 0.220523C13.426 0.150609 13.3375 0.0951496 13.2401 0.0573121C13.1427 0.0194747 13.0383 0 12.9329 0C12.8274 0 12.723 0.0194747 12.6256 0.0573121C12.5282 0.0951496 12.4397 0.150609 12.3652 0.220523C12.2906 0.290438 12.2315 0.373439 12.1911 0.464786C12.1508 0.556134 12.13 0.65404 12.13 0.752914C12.13 0.851788 12.1508 0.949694 12.1911 1.04104C12.2315 1.13239 12.2906 1.21539 12.3652 1.2853L14.628 3.40737C14.7024 3.47765 14.7908 3.53344 14.8882 3.5715C14.9857 3.60957 15.0902 3.62917 15.1958 3.62917C15.3013 3.62917 15.4058 3.60957 15.5033 3.5715C15.6007 3.53344 15.6891 3.47765 15.7635 3.40737C15.8384 3.33766 15.8979 3.25473 15.9385 3.16335C15.9791 3.07198 16 2.97397 16 2.87498C16 2.77599 15.9791 2.67798 15.9385 2.58661C15.8979 2.49523 15.8384 2.4123 15.7635 2.34259Z" />
        </svg>
      ),
      name: "PRO PLAN",
      price: "45",
      features: [
        "8 hours of excercises",
        "Consultation of Private Coach",
        "Free Fitness Merchandises",
      ],
    },
  ];


  return (
    <div className="plans-container" id='plans'>
      <div className="blur plans-blur-left"></div>
      <div className="blur plans-blur-right"></div>
      <div className="programs-header">
        <span className='strok-text'>READY TO START</span>
        <span>YOUR JOURNY</span>
        <span className='strok-text'>NOW WITH US</span>
      </div>


      <div className="plans">
        {plansData.map((p, i) => (
          <div className="plan" key={i}>
            {p.icon}
            <span>{p.name}</span>
            <span>$ {p.price}</span>
            <div className='features'>
              {p.features.map((f, i) => (
                <div className="feature">
                  <img src={whitetick} alt="" />
                  <span key={i}>{f}</span>
                </div>
              ))}
            </div>
           
            <div>
              <span>see more benefits -></span>
            </div>
            <button className="btn">
              Join Now
            </button>
          </div>
        ))}
      </div>

    </div>


  )
}

export default Plans